import Token from '@/di/di.token'

import useDi from '../useDi'

export default function usePricingService() {
  const { container } = useDi()
  const service = container.get(Token.PRICING_SERVICE)
  return { service }
}
